import { supabase } from "@/supabase";

const _TABLE = "staff_notification";

// In-app notifications for staff (bell in the header). Rows are created
// server-side (e.g. client review decisions → the campaign manager); the
// browser only lists them and marks them read.
export const NotificationService = {
  async list(limit = 30) {
    const { data, error } = await supabase.from(_TABLE).select("*").order("created_at", { ascending: false }).limit(limit);
    return { notifications: data || [], error: error?.message || null };
  },
  async unreadCount() {
    const { count, error } = await supabase.from(_TABLE).select("id", { count: "exact", head: true }).is("read_at", null);
    return { count: count || 0, error: error?.message || null };
  },
  async markRead(id) {
    const { error } = await supabase.from(_TABLE).update({ read_at: new Date() }).eq("id", id).is("read_at", null);
    return { error: error?.message || null };
  },
  async markAllRead() {
    const { error } = await supabase.from(_TABLE).update({ read_at: new Date() }).is("read_at", null);
    return { error: error?.message || null };
  },
  // Realtime: new rows for the signed-in user (RLS limits what the socket delivers).
  subscribe(userId, onInsert) {
    const ch = supabase
      .channel("staff_notification_" + userId)
      .on("postgres_changes", { event: "INSERT", schema: "public", table: _TABLE, filter: `user_id=eq.${userId}` }, (payload) => onInsert?.(payload.new))
      .subscribe();
    return () => supabase.removeChannel(ch);
  },
};
